export enum UploadStatusEnum {
  DONE = 'DONE',
  META_ARTICLE_DELETED = 'META_ARTICLE_DELETED',
  DONE_FALLBACK = 'DONE_FALLBACK',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  PARSING = 'PARSING',
  PARSING_FALLBACK = 'PARSING_FALLBACK',
}
